import React, { useState } from 'react';
import { useContact } from '../../context/ContactContext';
import { isV4 } from '../../lib/uiFlag';
import Copilot from './Copilot';
import CoachingPanel from './CoachingPanel';
import LiveCopilotChip from './LiveCopilotChip';
import SentimentPills from '../LeftRail/SentimentPills';
// v3 design parity (#112, epic #117): both rails, scoped to .v3-rail.
import '../../styles/rails-v3.css';


export default function RightRail() {
  // D28: notes live in context so they survive the ACW transition (this
  // component is unmounted when the wrap-up takes the centre).
  const { display, callNotes, setCallNotes } = useContact();
  // Console v4 (row 234): notes open from a button instead of a box that is
  // always showing. They stay open once anything is typed, so a note is never
  // hidden; the text itself lives in context exactly as in v3.
  const v4 = isV4();
  const [notesOpen, setNotesOpen] = useState(false);
  const showNotes = !v4 || notesOpen || Boolean(callNotes);

  if (!display) return <aside className="right-rail v3-rail" />;

  // Quick actions REMOVED (Storm, 2026-09-22, #112): Resolve only called
  // handleEnd() — a second End call that recorded no outcome and pre-filled
  // nothing — and Warm Transfer, Escalate and Full History were disabled
  // Phase 2 stubs (D28-b). End (left rail) and the wrap-up disposition cover
  // Resolve; Transfer lives in the left rail; caller history has its own
  // "Show N more". Do not re-add a control here without a real handler.

  return (
    <aside className="right-rail v3-rail">

      <div className="rr-header">
        <span className="rr-title">AI Assist</span>
        <span className="ai-live-badge">
          <span className="ai-live-dot" />
          LIVE
        </span>
      </div>

      <div className="rr-scroll">

        {/* Live sentiment and Coaching, together (#112, Storm 2026-09-22,
            vault #222). Coaching trigger 2 fires off the same live transcript
            feed the sparkline draws, so the cue sits right under the trend it
            follows from. General correlation only: no card-to-reading link
            (retired in #222 — the sparkline skips short replies, trigger 2
            doesn't). Copilot coaching v1 (2026-09-14) — read-only cues, own
            panel, separate from the Q&A box below. See CoachingPanel.jsx. */}
        <div className="rr-live-group">
          <SentimentPills />
          <CoachingPanel />
        </div>

        {/* Agent copilot — live Q&A over the tenant KB (D10) */}
        <Copilot />

        {/* Storm 2026-10-23 (row 35 tidy): Context Alerts and Suggested
            Responses removed from the rail. Neither was ever fed on a live
            call (connectData.js leaves both empty; only demo data filled
            them). Backlog rows 206 and 207. */}

        {/* 2026-09-17: Recommended Actions removed — see docs/ops/copilot-
            coming-soon-scoping-2026-09-17.md. This duplicated Coaching's
            functional space with the exact ranked-list-plus-confidence
            pattern Coaching's own scoping deliberately rejected. If more
            proactive guidance is wanted, extend Coaching's trigger set. */}

        {/* Live Copilot Phase 1 (2026-09-24, backlog register #11) — the
            reactive knowledge-answer chip replaces the old "Knowledge Base
            — Coming soon" stub (its source field was never populated by
            anything; see LiveCopilotChip.jsx for why this is the right
            surface for it, not a new one). */}
        <LiveCopilotChip />

        {/* Transfer options moved to the left rail, under the Transfer
            control (Storm 2026-09-29) — see LeftRail/TransferPanel.jsx. */}

      </div>

      {/* Storm 2026-10-23: the PII strip is removed (never fed live). A caller
          sharing personal details is now a coaching cue (lib/coachingTriggers.js,
          'personal-details'). Backlog row 208. */}
      {/* Call notes */}
      {showNotes ? (
        <div className="notes-wrap">
          <label className="notes-label" htmlFor="call-notes">Call Notes</label>
          <textarea
            id="call-notes"
            className="notes-area"
            placeholder="Add notes for after-call work…"
            value={callNotes}
            onChange={e => setCallNotes(e.target.value)}
            autoFocus={v4 && notesOpen && !callNotes}
          />
        </div>
      ) : (
        <div className="notes-wrap">
          <button type="button" className="v4-btn" onClick={() => setNotesOpen(true)}>Call notes</button>
        </div>
      )}

    </aside>
  );
}
